/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost:9000".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration!: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: string = "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 *
 * @export
 * @interface AppUserCreate
 */
export interface AppUserCreate {
    /**
     *
     * @type {string}
     * @memberof AppUserCreate
     */
    username: string;
    /**
     *
     * @type {string}
     * @memberof AppUserCreate
     */
    password: string;
    /**
     *
     * @type {string}
     * @memberof AppUserCreate
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof AppUserCreate
     */
    lastName?: string;
    /**
     *
     * @type {string}
     * @memberof AppUserCreate
     */
    email: string;
    /**
     *
     * @type {string}
     * @memberof AppUserCreate
     */
    avatar?: string;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof AppUserCreate
     */
    keyValues?: { [key: string]: string; };
    /**
     *
     * @type {boolean}
     * @memberof AppUserCreate
     */
    admin: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AppUserCreate
     */
    enabled: boolean;
}
/**
 *
 * @export
 * @interface AppUserRead
 */
export interface AppUserRead {
    /**
     *
     * @type {string}
     * @memberof AppUserRead
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof AppUserRead
     */
    username?: string;
    /**
     *
     * @type {string}
     * @memberof AppUserRead
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof AppUserRead
     */
    lastName?: string;
    /**
     *
     * @type {string}
     * @memberof AppUserRead
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof AppUserRead
     */
    avatar?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof AppUserRead
     */
    roles?: Array<string>;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof AppUserRead
     */
    keyValues?: { [key: string]: string; };
    /**
     *
     * @type {boolean}
     * @memberof AppUserRead
     */
    enabled?: boolean;
    /**
     *
     * @type {Date}
     * @memberof AppUserRead
     */
    created?: Date;
    /**
     *
     * @type {Date}
     * @memberof AppUserRead
     */
    lastLogin?: Date;
}
/**
 *
 * @export
 * @interface AppUserUpdate
 */
export interface AppUserUpdate {
    /**
     *
     * @type {string}
     * @memberof AppUserUpdate
     */
    password?: string;
    /**
     *
     * @type {string}
     * @memberof AppUserUpdate
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof AppUserUpdate
     */
    lastName?: string;
    /**
     *
     * @type {string}
     * @memberof AppUserUpdate
     */
    avatar?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof AppUserUpdate
     */
    roles?: Array<string>;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof AppUserUpdate
     */
    keyValues?: { [key: string]: string; };
    /**
     *
     * @type {boolean}
     * @memberof AppUserUpdate
     */
    enabled?: boolean;
}
/**
 *
 * @export
 * @interface ClientEntity
 */
export interface ClientEntity {
    /**
     *
     * @type {string}
     * @memberof ClientEntity
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof ClientEntity
     */
    name?: string;
    /**
     *
     * @type {Array<TypeRead>}
     * @memberof ClientEntity
     */
    types?: Array<TypeRead>;
    /**
     *
     * @type {Array<LockerRead>}
     * @memberof ClientEntity
     */
    lockers?: Array<LockerRead>;
}
/**
 *
 * @export
 * @interface ClientRead
 */
export interface ClientRead {
    /**
     *
     * @type {string}
     * @memberof ClientRead
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof ClientRead
     */
    name?: string;
    /**
     *
     * @type {Array<TypeRead>}
     * @memberof ClientRead
     */
    types?: Array<TypeRead>;
    /**
     *
     * @type {Array<LockerRead>}
     * @memberof ClientRead
     */
    lockers?: Array<LockerRead>;
}
/**
 *
 * @export
 * @interface ClientWrite
 */
export interface ClientWrite {
    /**
     *
     * @type {string}
     * @memberof ClientWrite
     */
    name?: string;
    /**
     *
     * @type {Array<TypeRead>}
     * @memberof ClientWrite
     */
    types?: Array<TypeRead>;
    /**
     *
     * @type {Array<LockerRead>}
     * @memberof ClientWrite
     */
    lockers?: Array<LockerRead>;
}
/**
 *
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     *
     * @type {number}
     * @memberof ErrorResponse
     */
    status?: number;
    /**
     *
     * @type {string}
     * @memberof ErrorResponse
     */
    message?: string;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof ErrorResponse
     */
    fields?: { [key: string]: string; };
}
/**
 *
 * @export
 * @interface ForgotPasswordRequest
 */
export interface ForgotPasswordRequest {
    /**
     *
     * @type {string}
     * @memberof ForgotPasswordRequest
     */
    username?: string;
    /**
     *
     * @type {string}
     * @memberof ForgotPasswordRequest
     */
    email?: string;
}
/**
 *
 * @export
 * @interface ItemEntity
 */
export interface ItemEntity {
    /**
     *
     * @type {string}
     * @memberof ItemEntity
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof ItemEntity
     */
    clientId: string;
    /**
     *
     * @type {string}
     * @memberof ItemEntity
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof ItemEntity
     */
    date?: string;
    /**
     *
     * @type {string}
     * @memberof ItemEntity
     */
    subject?: string;
    /**
     *
     * @type {string}
     * @memberof ItemEntity
     */
    portions?: string;
    /**
     *
     * @type {boolean}
     * @memberof ItemEntity
     */
    active?: boolean;
    /**
     *
     * @type {LockerRead}
     * @memberof ItemEntity
     */
    locker?: LockerRead;
    /**
     *
     * @type {TypeRead}
     * @memberof ItemEntity
     */
    type?: TypeRead;
    /**
     *
     * @type {string}
     * @memberof ItemEntity
     */
    icon?: string;
}
/**
 *
 * @export
 * @interface ItemRead
 */
export interface ItemRead {
    /**
     *
     * @type {string}
     * @memberof ItemRead
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof ItemRead
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof ItemRead
     */
    date?: string;
    /**
     *
     * @type {string}
     * @memberof ItemRead
     */
    subject?: string;
    /**
     *
     * @type {string}
     * @memberof ItemRead
     */
    portions?: string;
    /**
     *
     * @type {boolean}
     * @memberof ItemRead
     */
    active?: boolean;
    /**
     *
     * @type {number}
     * @memberof ItemRead
     */
    subjectCount?: number;
    /**
     *
     * @type {LockerRead}
     * @memberof ItemRead
     */
    locker?: LockerRead;
    /**
     *
     * @type {TypeRead}
     * @memberof ItemRead
     */
    type?: TypeRead;
}
/**
 *
 * @export
 * @interface ItemReadLightDto
 */
export interface ItemReadLightDto {
    /**
     *
     * @type {string}
     * @memberof ItemReadLightDto
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof ItemReadLightDto
     */
    date?: string;
    /**
     *
     * @type {number}
     * @memberof ItemReadLightDto
     */
    amount?: number;
}
/**
 *
 * @export
 * @interface ItemReadOverviewLocker
 */
export interface ItemReadOverviewLocker {
    /**
     *
     * @type {string}
     * @memberof ItemReadOverviewLocker
     */
    name?: string;
    /**
     *
     * @type {LockerRead}
     * @memberof ItemReadOverviewLocker
     */
    locker?: LockerRead;
    /**
     *
     * @type {string}
     * @memberof ItemReadOverviewLocker
     */
    subject?: string;
    /**
     *
     * @type {number}
     * @memberof ItemReadOverviewLocker
     */
    amount?: number;
}
/**
 *
 * @export
 * @interface ItemWrite
 */
export interface ItemWrite {
    /**
     *
     * @type {string}
     * @memberof ItemWrite
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof ItemWrite
     */
    subject?: string;
    /**
     *
     * @type {string}
     * @memberof ItemWrite
     */
    portions?: string;
    /**
     *
     * @type {string}
     * @memberof ItemWrite
     */
    lockerId?: string;
    /**
     *
     * @type {string}
     * @memberof ItemWrite
     */
    typeId?: string;
    /**
     *
     * @type {number}
     * @memberof ItemWrite
     */
    amount?: number;
}
/**
 *
 * @export
 * @interface JwtTokenBundle
 */
export interface JwtTokenBundle {
    /**
     *
     * @type {string}
     * @memberof JwtTokenBundle
     */
    token?: string;
    /**
     *
     * @type {string}
     * @memberof JwtTokenBundle
     */
    refreshToken?: string;
}
/**
 *
 * @export
 * @interface LockerRead
 */
export interface LockerRead {
    /**
     *
     * @type {string}
     * @memberof LockerRead
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof LockerRead
     */
    name?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof LockerRead
     */
    subjects?: Array<string>;
}
/**
 *
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     *
     * @type {string}
     * @memberof LoginRequest
     */
    username: string;
    /**
     *
     * @type {string}
     * @memberof LoginRequest
     */
    password: string;
}
/**
 *
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
    /**
     *
     * @type {JwtTokenBundle}
     * @memberof LoginResponse
     */
    jwtTokenBundle?: JwtTokenBundle;
    /**
     *
     * @type {AppUserRead}
     * @memberof LoginResponse
     */
    user?: AppUserRead;
}
/**
 *
 * @export
 * @interface OverviewDto
 */
export interface OverviewDto {
    /**
     *
     * @type {TypeRead}
     * @memberof OverviewDto
     */
    type?: TypeRead;
    /**
     *
     * @type {Array<ItemReadLightDto>}
     * @memberof OverviewDto
     */
    items?: Array<ItemReadLightDto>;
    /**
     *
     * @type {boolean}
     * @memberof OverviewDto
     */
    active?: boolean;
}
/**
 *
 * @export
 * @interface PageableResultAppUserRead
 */
export interface PageableResultAppUserRead {
    /**
     *
     * @type {number}
     * @memberof PageableResultAppUserRead
     */
    totalElements?: number;
    /**
     *
     * @type {number}
     * @memberof PageableResultAppUserRead
     */
    totalPages?: number;
    /**
     *
     * @type {number}
     * @memberof PageableResultAppUserRead
     */
    page?: number;
    /**
     *
     * @type {number}
     * @memberof PageableResultAppUserRead
     */
    pageSize?: number;
    /**
     *
     * @type {Array<AppUserRead>}
     * @memberof PageableResultAppUserRead
     */
    content?: Array<AppUserRead>;
}
/**
 *
 * @export
 * @interface PageableResultClientRead
 */
export interface PageableResultClientRead {
    /**
     *
     * @type {number}
     * @memberof PageableResultClientRead
     */
    totalElements?: number;
    /**
     *
     * @type {number}
     * @memberof PageableResultClientRead
     */
    totalPages?: number;
    /**
     *
     * @type {number}
     * @memberof PageableResultClientRead
     */
    page?: number;
    /**
     *
     * @type {number}
     * @memberof PageableResultClientRead
     */
    pageSize?: number;
    /**
     *
     * @type {Array<ClientRead>}
     * @memberof PageableResultClientRead
     */
    content?: Array<ClientRead>;
}
/**
 *
 * @export
 * @interface PasswordChangeRequest
 */
export interface PasswordChangeRequest {
    /**
     *
     * @type {string}
     * @memberof PasswordChangeRequest
     */
    currentPassword: string;
    /**
     *
     * @type {string}
     * @memberof PasswordChangeRequest
     */
    newPassword: string;
}
/**
 *
 * @export
 * @interface PerformPasswordResetRequest
 */
export interface PerformPasswordResetRequest {
    /**
     *
     * @type {string}
     * @memberof PerformPasswordResetRequest
     */
    verification: string;
    /**
     *
     * @type {string}
     * @memberof PerformPasswordResetRequest
     */
    password: string;
}
/**
 *
 * @export
 * @interface SecurityConfiguration
 */
export interface SecurityConfiguration {
    /**
     *
     * @type {string}
     * @memberof SecurityConfiguration
     */
    apiKey?: string;
    /**
     *
     * @type {string}
     * @memberof SecurityConfiguration
     */
    apiKeyVehicle?: string;
    /**
     *
     * @type {string}
     * @memberof SecurityConfiguration
     */
    apiKeyName?: string;
    /**
     *
     * @type {string}
     * @memberof SecurityConfiguration
     */
    clientId?: string;
    /**
     *
     * @type {string}
     * @memberof SecurityConfiguration
     */
    clientSecret?: string;
    /**
     *
     * @type {string}
     * @memberof SecurityConfiguration
     */
    realm?: string;
    /**
     *
     * @type {string}
     * @memberof SecurityConfiguration
     */
    appName?: string;
    /**
     *
     * @type {string}
     * @memberof SecurityConfiguration
     */
    scopeSeparator?: string;
    /**
     *
     * @type {{ [key: string]: any; }}
     * @memberof SecurityConfiguration
     */
    additionalQueryStringParams?: { [key: string]: any; };
    /**
     *
     * @type {boolean}
     * @memberof SecurityConfiguration
     */
    useBasicAuthenticationWithAccessCodeGrant?: boolean;
}
/**
 *
 * @export
 * @interface SwaggerResource
 */
export interface SwaggerResource {
    /**
     *
     * @type {string}
     * @memberof SwaggerResource
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof SwaggerResource
     */
    url?: string;
    /**
     *
     * @type {string}
     * @memberof SwaggerResource
     */
    swaggerVersion?: string;
    /**
     *
     * @type {string}
     * @memberof SwaggerResource
     */
    location?: string;
}
/**
 *
 * @export
 * @interface TypeRead
 */
export interface TypeRead {
    /**
     *
     * @type {string}
     * @memberof TypeRead
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof TypeRead
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof TypeRead
     */
    icon?: string;
}
/**
 *
 * @export
 * @interface UiConfiguration
 */
export interface UiConfiguration {
    /**
     *
     * @type {boolean}
     * @memberof UiConfiguration
     */
    deepLinking?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof UiConfiguration
     */
    displayOperationId?: boolean;
    /**
     *
     * @type {number}
     * @memberof UiConfiguration
     */
    defaultModelsExpandDepth?: number;
    /**
     *
     * @type {number}
     * @memberof UiConfiguration
     */
    defaultModelExpandDepth?: number;
    /**
     *
     * @type {string}
     * @memberof UiConfiguration
     */
    defaultModelRendering?: UiConfiguration.DefaultModelRenderingEnum;
    /**
     *
     * @type {boolean}
     * @memberof UiConfiguration
     */
    displayRequestDuration?: boolean;
    /**
     *
     * @type {string}
     * @memberof UiConfiguration
     */
    docExpansion?: UiConfiguration.DocExpansionEnum;
    /**
     *
     * @type {any}
     * @memberof UiConfiguration
     */
    filter?: any;
    /**
     *
     * @type {number}
     * @memberof UiConfiguration
     */
    maxDisplayedTags?: number;
    /**
     *
     * @type {string}
     * @memberof UiConfiguration
     */
    operationsSorter?: UiConfiguration.OperationsSorterEnum;
    /**
     *
     * @type {boolean}
     * @memberof UiConfiguration
     */
    showExtensions?: boolean;
    /**
     *
     * @type {string}
     * @memberof UiConfiguration
     */
    tagsSorter?: UiConfiguration.TagsSorterEnum;
    /**
     *
     * @type {string}
     * @memberof UiConfiguration
     */
    validatorUrl?: string;
    /**
     *
     * @type {string}
     * @memberof UiConfiguration
     */
    apisSorter?: string;
    /**
     *
     * @type {boolean}
     * @memberof UiConfiguration
     */
    jsonEditor?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof UiConfiguration
     */
    showRequestHeaders?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof UiConfiguration
     */
    supportedSubmitMethods?: Array<string>;
}

/**
 * @export
 * @namespace UiConfiguration
 */
export namespace UiConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum DefaultModelRenderingEnum {
        Example = <any> 'example',
        Model = <any> 'model'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DocExpansionEnum {
        None = <any> 'none',
        List = <any> 'list',
        Full = <any> 'full'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OperationsSorterEnum {
        Alpha = <any> 'alpha',
        Method = <any> 'method'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TagsSorterEnum {
        Alpha = <any> 'alpha'
    }
}
/**
 *
 * @export
 * @interface UpdateProfileRequest
 */
export interface UpdateProfileRequest {
    /**
     *
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    lastName?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    avatar?: string;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof UpdateProfileRequest
     */
    keyValues?: { [key: string]: string; };
}
/**
 *
 * @export
 * @interface ValidationResponseEmailErrorCodes
 */
export interface ValidationResponseEmailErrorCodes {
    /**
     *
     * @type {boolean}
     * @memberof ValidationResponseEmailErrorCodes
     */
    valid?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ValidationResponseEmailErrorCodes
     */
    errorCodes?: Array<ValidationResponseEmailErrorCodes.ErrorCodesEnum>;
    /**
     *
     * @type {string}
     * @memberof ValidationResponseEmailErrorCodes
     */
    type: string;
}

/**
 * @export
 * @namespace ValidationResponseEmailErrorCodes
 */
export namespace ValidationResponseEmailErrorCodes {
    /**
     * @export
     * @enum {string}
     */
    export enum ErrorCodesEnum {
        ALREADYTAKEN = <any> 'ALREADY_TAKEN',
        INVALID = <any> 'INVALID'
    }
}
/**
 *
 * @export
 * @interface ValidationResponsePasswordErrorCodes
 */
export interface ValidationResponsePasswordErrorCodes {
    /**
     *
     * @type {boolean}
     * @memberof ValidationResponsePasswordErrorCodes
     */
    valid?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ValidationResponsePasswordErrorCodes
     */
    errorCodes?: Array<ValidationResponsePasswordErrorCodes.ErrorCodesEnum>;
    /**
     *
     * @type {string}
     * @memberof ValidationResponsePasswordErrorCodes
     */
    type: string;
}

/**
 * @export
 * @namespace ValidationResponsePasswordErrorCodes
 */
export namespace ValidationResponsePasswordErrorCodes {
    /**
     * @export
     * @enum {string}
     */
    export enum ErrorCodesEnum {
        TOOSHORT = <any> 'TOO_SHORT',
        TOOLONG = <any> 'TOO_LONG',
        INSUFFICIENTLOWERCASE = <any> 'INSUFFICIENT_LOWERCASE',
        INSUFFICIENTUPPERCASE = <any> 'INSUFFICIENT_UPPERCASE',
        INSUFFICIENTDIGIT = <any> 'INSUFFICIENT_DIGIT',
        INSUFFICIENTSPECIAL = <any> 'INSUFFICIENT_SPECIAL',
        INVALIDCURRENTPASSWORD = <any> 'INVALID_CURRENT_PASSWORD'
    }
}
/**
 *
 * @export
 * @interface ValidationResponseTokenErrorCodes
 */
export interface ValidationResponseTokenErrorCodes {
    /**
     *
     * @type {boolean}
     * @memberof ValidationResponseTokenErrorCodes
     */
    valid?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ValidationResponseTokenErrorCodes
     */
    errorCodes?: Array<ValidationResponseTokenErrorCodes.ErrorCodesEnum>;
    /**
     *
     * @type {string}
     * @memberof ValidationResponseTokenErrorCodes
     */
    type: string;
}

/**
 * @export
 * @namespace ValidationResponseTokenErrorCodes
 */
export namespace ValidationResponseTokenErrorCodes {
    /**
     * @export
     * @enum {string}
     */
    export enum ErrorCodesEnum {
        EXPIRED = <any> 'EXPIRED'
    }
}
/**
 *
 * @export
 * @interface ValidationResponseUsernameErrorCodes
 */
export interface ValidationResponseUsernameErrorCodes {
    /**
     *
     * @type {boolean}
     * @memberof ValidationResponseUsernameErrorCodes
     */
    valid?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof ValidationResponseUsernameErrorCodes
     */
    errorCodes?: Array<ValidationResponseUsernameErrorCodes.ErrorCodesEnum>;
    /**
     *
     * @type {string}
     * @memberof ValidationResponseUsernameErrorCodes
     */
    type: string;
}

/**
 * @export
 * @namespace ValidationResponseUsernameErrorCodes
 */
export namespace ValidationResponseUsernameErrorCodes {
    /**
     * @export
     * @enum {string}
     */
    export enum ErrorCodesEnum {
        ALREADYTAKEN = <any> 'ALREADY_TAKEN',
        TOOSHORT = <any> 'TOO_SHORT',
        TOOLONG = <any> 'TOO_LONG',
        NOTALLOWEDCHAR = <any> 'NOT_ALLOWED_CHAR'
    }
}
/**
 * ApiResourceControllerApi - fetch parameter creator
 * @export
 */
export const ApiResourceControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/security`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration1(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/security`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'HEAD' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration2(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/security`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration3(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/security`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration4(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/security`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration5(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/security`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration6(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/security`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'OPTIONS' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources1(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'HEAD' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources2(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources3(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources4(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources5(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources6(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'OPTIONS' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/ui`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration1(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/ui`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'HEAD' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration2(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/ui`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration3(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/ui`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration4(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/ui`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration5(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/ui`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration6(options: any = {}): FetchArgs {
            const localVarPath = `/swagger-resources/configuration/ui`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'OPTIONS' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiResourceControllerApi - functional programming interface
 * @export
 */
export const ApiResourceControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SecurityConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).securityConfiguration(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration1(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SecurityConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).securityConfiguration1(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration2(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SecurityConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).securityConfiguration2(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration3(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SecurityConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).securityConfiguration3(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration4(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SecurityConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).securityConfiguration4(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration5(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SecurityConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).securityConfiguration5(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration6(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SecurityConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).securityConfiguration6(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SwaggerResource>> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).swaggerResources(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources1(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SwaggerResource>> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).swaggerResources1(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources2(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SwaggerResource>> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).swaggerResources2(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources3(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SwaggerResource>> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).swaggerResources3(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources4(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SwaggerResource>> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).swaggerResources4(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources5(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SwaggerResource>> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).swaggerResources5(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources6(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SwaggerResource>> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).swaggerResources6(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UiConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).uiConfiguration(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration1(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UiConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).uiConfiguration1(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration2(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UiConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).uiConfiguration2(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration3(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UiConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).uiConfiguration3(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration4(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UiConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).uiConfiguration4(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration5(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UiConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).uiConfiguration5(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration6(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UiConfiguration> {
            const localVarFetchArgs = ApiResourceControllerApiFetchParamCreator(configuration).uiConfiguration6(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ApiResourceControllerApi - factory interface
 * @export
 */
export const ApiResourceControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration(options?: any) {
            return ApiResourceControllerApiFp(configuration).securityConfiguration(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration1(options?: any) {
            return ApiResourceControllerApiFp(configuration).securityConfiguration1(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration2(options?: any) {
            return ApiResourceControllerApiFp(configuration).securityConfiguration2(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration3(options?: any) {
            return ApiResourceControllerApiFp(configuration).securityConfiguration3(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration4(options?: any) {
            return ApiResourceControllerApiFp(configuration).securityConfiguration4(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration5(options?: any) {
            return ApiResourceControllerApiFp(configuration).securityConfiguration5(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityConfiguration6(options?: any) {
            return ApiResourceControllerApiFp(configuration).securityConfiguration6(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources(options?: any) {
            return ApiResourceControllerApiFp(configuration).swaggerResources(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources1(options?: any) {
            return ApiResourceControllerApiFp(configuration).swaggerResources1(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources2(options?: any) {
            return ApiResourceControllerApiFp(configuration).swaggerResources2(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources3(options?: any) {
            return ApiResourceControllerApiFp(configuration).swaggerResources3(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources4(options?: any) {
            return ApiResourceControllerApiFp(configuration).swaggerResources4(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources5(options?: any) {
            return ApiResourceControllerApiFp(configuration).swaggerResources5(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerResources6(options?: any) {
            return ApiResourceControllerApiFp(configuration).swaggerResources6(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration(options?: any) {
            return ApiResourceControllerApiFp(configuration).uiConfiguration(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration1(options?: any) {
            return ApiResourceControllerApiFp(configuration).uiConfiguration1(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration2(options?: any) {
            return ApiResourceControllerApiFp(configuration).uiConfiguration2(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration3(options?: any) {
            return ApiResourceControllerApiFp(configuration).uiConfiguration3(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration4(options?: any) {
            return ApiResourceControllerApiFp(configuration).uiConfiguration4(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration5(options?: any) {
            return ApiResourceControllerApiFp(configuration).uiConfiguration5(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uiConfiguration6(options?: any) {
            return ApiResourceControllerApiFp(configuration).uiConfiguration6(options)(fetch, basePath);
        },
    };
};

/**
 * ApiResourceControllerApi - object-oriented interface
 * @export
 * @class ApiResourceControllerApi
 * @extends {BaseAPI}
 */
export class ApiResourceControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public securityConfiguration(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).securityConfiguration(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public securityConfiguration1(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).securityConfiguration1(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public securityConfiguration2(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).securityConfiguration2(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public securityConfiguration3(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).securityConfiguration3(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public securityConfiguration4(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).securityConfiguration4(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public securityConfiguration5(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).securityConfiguration5(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public securityConfiguration6(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).securityConfiguration6(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public swaggerResources(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).swaggerResources(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public swaggerResources1(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).swaggerResources1(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public swaggerResources2(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).swaggerResources2(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public swaggerResources3(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).swaggerResources3(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public swaggerResources4(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).swaggerResources4(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public swaggerResources5(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).swaggerResources5(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public swaggerResources6(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).swaggerResources6(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public uiConfiguration(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).uiConfiguration(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public uiConfiguration1(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).uiConfiguration1(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public uiConfiguration2(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).uiConfiguration2(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public uiConfiguration3(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).uiConfiguration3(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public uiConfiguration4(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).uiConfiguration4(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public uiConfiguration5(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).uiConfiguration5(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiResourceControllerApi
     */
    public uiConfiguration6(options?: any) {
        return ApiResourceControllerApiFp(this.configuration).uiConfiguration6(options)(this.fetch, this.basePath);
    }

}
/**
 * AppUserControllerApi - fetch parameter creator
 * @export
 */
export const AppUserControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {AppUserCreate} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1(body: AppUserCreate, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling create1.');
            }
            const localVarPath = `/api/user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AppUserCreate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete1(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling delete1.');
            }
            const localVarPath = `/api/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find1(options: any = {}): FetchArgs {
            const localVarPath = `/api/user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AppUserUpdate} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch(body: AppUserUpdate, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling patch.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling patch.');
            }
            const localVarPath = `/api/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AppUserUpdate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppUserControllerApi - functional programming interface
 * @export
 */
export const AppUserControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {AppUserCreate} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1(body: AppUserCreate, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AppUserRead> {
            const localVarFetchArgs = AppUserControllerApiFetchParamCreator(configuration).create1(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete1(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AppUserControllerApiFetchParamCreator(configuration).delete1(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find1(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageableResultAppUserRead> {
            const localVarFetchArgs = AppUserControllerApiFetchParamCreator(configuration).find1(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {AppUserUpdate} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch(body: AppUserUpdate, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AppUserRead> {
            const localVarFetchArgs = AppUserControllerApiFetchParamCreator(configuration).patch(body, id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AppUserControllerApi - factory interface
 * @export
 */
export const AppUserControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @param {AppUserCreate} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1(body: AppUserCreate, options?: any) {
            return AppUserControllerApiFp(configuration).create1(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete1(id: string, options?: any) {
            return AppUserControllerApiFp(configuration).delete1(id, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find1(options?: any) {
            return AppUserControllerApiFp(configuration).find1(options)(fetch, basePath);
        },
        /**
         *
         * @param {AppUserUpdate} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch(body: AppUserUpdate, id: string, options?: any) {
            return AppUserControllerApiFp(configuration).patch(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AppUserControllerApi - object-oriented interface
 * @export
 * @class AppUserControllerApi
 * @extends {BaseAPI}
 */
export class AppUserControllerApi extends BaseAPI {
    /**
     *
     * @param {AppUserCreate} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public create1(body: AppUserCreate, options?: any) {
        return AppUserControllerApiFp(this.configuration).create1(body, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public delete1(id: string, options?: any) {
        return AppUserControllerApiFp(this.configuration).delete1(id, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public find1(options?: any) {
        return AppUserControllerApiFp(this.configuration).find1(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {AppUserUpdate} body
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppUserControllerApi
     */
    public patch(body: AppUserUpdate, id: string, options?: any) {
        return AppUserControllerApiFp(this.configuration).patch(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * AuthenticationControllerApi - fetch parameter creator
 * @export
 */
export const AuthenticationControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {PasswordChangeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(body: PasswordChangeRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling changePassword.');
            }
            const localVarPath = `/auth/change-password`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PasswordChangeRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthenticated(options: any = {}): FetchArgs {
            const localVarPath = `/auth/me`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {LoginRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(body: LoginRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling login.');
            }
            const localVarPath = `/auth/login`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"LoginRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(options: any = {}): FetchArgs {
            const localVarPath = `/auth/refresh`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {UpdateProfileRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(body: UpdateProfileRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateProfile.');
            }
            const localVarPath = `/auth/update-profile`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateProfileRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationControllerApi - functional programming interface
 * @export
 */
export const AuthenticationControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {PasswordChangeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(body: PasswordChangeRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AuthenticationControllerApiFetchParamCreator(configuration).changePassword(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthenticated(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AppUserRead> {
            const localVarFetchArgs = AuthenticationControllerApiFetchParamCreator(configuration).getAuthenticated(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {LoginRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(body: LoginRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LoginResponse> {
            const localVarFetchArgs = AuthenticationControllerApiFetchParamCreator(configuration).login(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = AuthenticationControllerApiFetchParamCreator(configuration).refreshToken(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {UpdateProfileRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(body: UpdateProfileRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AuthenticationControllerApiFetchParamCreator(configuration).updateProfile(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AuthenticationControllerApi - factory interface
 * @export
 */
export const AuthenticationControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @param {PasswordChangeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(body: PasswordChangeRequest, options?: any) {
            return AuthenticationControllerApiFp(configuration).changePassword(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthenticated(options?: any) {
            return AuthenticationControllerApiFp(configuration).getAuthenticated(options)(fetch, basePath);
        },
        /**
         *
         * @param {LoginRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(body: LoginRequest, options?: any) {
            return AuthenticationControllerApiFp(configuration).login(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(options?: any) {
            return AuthenticationControllerApiFp(configuration).refreshToken(options)(fetch, basePath);
        },
        /**
         *
         * @param {UpdateProfileRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(body: UpdateProfileRequest, options?: any) {
            return AuthenticationControllerApiFp(configuration).updateProfile(body, options)(fetch, basePath);
        },
    };
};

/**
 * AuthenticationControllerApi - object-oriented interface
 * @export
 * @class AuthenticationControllerApi
 * @extends {BaseAPI}
 */
export class AuthenticationControllerApi extends BaseAPI {
    /**
     *
     * @param {PasswordChangeRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public changePassword(body: PasswordChangeRequest, options?: any) {
        return AuthenticationControllerApiFp(this.configuration).changePassword(body, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public getAuthenticated(options?: any) {
        return AuthenticationControllerApiFp(this.configuration).getAuthenticated(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {LoginRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public login(body: LoginRequest, options?: any) {
        return AuthenticationControllerApiFp(this.configuration).login(body, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public refreshToken(options?: any) {
        return AuthenticationControllerApiFp(this.configuration).refreshToken(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {UpdateProfileRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public updateProfile(body: UpdateProfileRequest, options?: any) {
        return AuthenticationControllerApiFp(this.configuration).updateProfile(body, options)(this.fetch, this.basePath);
    }

}
/**
 * ClientControllerApi - fetch parameter creator
 * @export
 */
export const ClientControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            const localVarPath = `/api/client/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ClientWrite} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: ClientWrite, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling create.');
            }
            const localVarPath = `/api/client`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ClientWrite" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find(options: any = {}): FetchArgs {
            const localVarPath = `/api/client`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getById.');
            }
            const localVarPath = `/api/client/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClient(options: any = {}): FetchArgs {
            const localVarPath = `/api/client/getDetails`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLockers(options: any = {}): FetchArgs {
            const localVarPath = `/api/client/getLockers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypes(options: any = {}): FetchArgs {
            const localVarPath = `/api/client/getTypes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ClientWrite} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(body: ClientWrite, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling update.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling update.');
            }
            const localVarPath = `/api/client/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ClientWrite" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientControllerApi - functional programming interface
 * @export
 */
export const ClientControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ClientControllerApiFetchParamCreator(configuration)._delete(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ClientWrite} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: ClientWrite, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ClientControllerApiFetchParamCreator(configuration).create(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageableResultClientRead> {
            const localVarFetchArgs = ClientControllerApiFetchParamCreator(configuration).find(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ClientControllerApiFetchParamCreator(configuration).getById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClient(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ClientEntity> {
            const localVarFetchArgs = ClientControllerApiFetchParamCreator(configuration).getClient(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLockers(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LockerRead>> {
            const localVarFetchArgs = ClientControllerApiFetchParamCreator(configuration).getLockers(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypes(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TypeRead>> {
            const localVarFetchArgs = ClientControllerApiFetchParamCreator(configuration).getTypes(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ClientWrite} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(body: ClientWrite, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ClientControllerApiFetchParamCreator(configuration).update(body, id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ClientControllerApi - factory interface
 * @export
 */
export const ClientControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any) {
            return ClientControllerApiFp(configuration)._delete(id, options)(fetch, basePath);
        },
        /**
         *
         * @param {ClientWrite} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: ClientWrite, options?: any) {
            return ClientControllerApiFp(configuration).create(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find(options?: any) {
            return ClientControllerApiFp(configuration).find(options)(fetch, basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id: string, options?: any) {
            return ClientControllerApiFp(configuration).getById(id, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClient(options?: any) {
            return ClientControllerApiFp(configuration).getClient(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLockers(options?: any) {
            return ClientControllerApiFp(configuration).getLockers(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypes(options?: any) {
            return ClientControllerApiFp(configuration).getTypes(options)(fetch, basePath);
        },
        /**
         *
         * @param {ClientWrite} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(body: ClientWrite, id: string, options?: any) {
            return ClientControllerApiFp(configuration).update(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * ClientControllerApi - object-oriented interface
 * @export
 * @class ClientControllerApi
 * @extends {BaseAPI}
 */
export class ClientControllerApi extends BaseAPI {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientControllerApi
     */
    public _delete(id: string, options?: any) {
        return ClientControllerApiFp(this.configuration)._delete(id, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {ClientWrite} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientControllerApi
     */
    public create(body: ClientWrite, options?: any) {
        return ClientControllerApiFp(this.configuration).create(body, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientControllerApi
     */
    public find(options?: any) {
        return ClientControllerApiFp(this.configuration).find(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientControllerApi
     */
    public getById(id: string, options?: any) {
        return ClientControllerApiFp(this.configuration).getById(id, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientControllerApi
     */
    public getClient(options?: any) {
        return ClientControllerApiFp(this.configuration).getClient(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientControllerApi
     */
    public getLockers(options?: any) {
        return ClientControllerApiFp(this.configuration).getLockers(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientControllerApi
     */
    public getTypes(options?: any) {
        return ClientControllerApiFp(this.configuration).getTypes(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {ClientWrite} body
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientControllerApi
     */
    public update(body: ClientWrite, id: string, options?: any) {
        return ClientControllerApiFp(this.configuration).update(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * ForgotPasswordControllerApi - fetch parameter creator
 * @export
 */
export const ForgotPasswordControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {ForgotPasswordRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(body: ForgotPasswordRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling forgotPassword.');
            }
            const localVarPath = `/auth/forgot-password`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ForgotPasswordRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PerformPasswordResetRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body: PerformPasswordResetRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling resetPassword.');
            }
            const localVarPath = `/auth/reset-password`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PerformPasswordResetRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForgotPasswordControllerApi - functional programming interface
 * @export
 */
export const ForgotPasswordControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {ForgotPasswordRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(body: ForgotPasswordRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ForgotPasswordControllerApiFetchParamCreator(configuration).forgotPassword(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {PerformPasswordResetRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body: PerformPasswordResetRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ForgotPasswordControllerApiFetchParamCreator(configuration).resetPassword(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ForgotPasswordControllerApi - factory interface
 * @export
 */
export const ForgotPasswordControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @param {ForgotPasswordRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(body: ForgotPasswordRequest, options?: any) {
            return ForgotPasswordControllerApiFp(configuration).forgotPassword(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {PerformPasswordResetRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body: PerformPasswordResetRequest, options?: any) {
            return ForgotPasswordControllerApiFp(configuration).resetPassword(body, options)(fetch, basePath);
        },
    };
};

/**
 * ForgotPasswordControllerApi - object-oriented interface
 * @export
 * @class ForgotPasswordControllerApi
 * @extends {BaseAPI}
 */
export class ForgotPasswordControllerApi extends BaseAPI {
    /**
     *
     * @param {ForgotPasswordRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForgotPasswordControllerApi
     */
    public forgotPassword(body: ForgotPasswordRequest, options?: any) {
        return ForgotPasswordControllerApiFp(this.configuration).forgotPassword(body, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {PerformPasswordResetRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForgotPasswordControllerApi
     */
    public resetPassword(body: PerformPasswordResetRequest, options?: any) {
        return ForgotPasswordControllerApiFp(this.configuration).resetPassword(body, options)(this.fetch, this.basePath);
    }

}
/**
 * ItemControllerApi - fetch parameter creator
 * @export
 */
export const ItemControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {ItemWrite} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createItem(body: ItemWrite, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createItem.');
            }
            const localVarPath = `/api/item/insert`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ItemWrite" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteById.');
            }
            const localVarPath = `/api/item/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<string>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByIds(body: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling deleteByIds.');
            }
            const localVarPath = `/api/item/deleteItems`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;string&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory(options: any = {}): FetchArgs {
            const localVarPath = `/api/item/history`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemById(itemId: string, options: any = {}): FetchArgs {
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling getItemById.');
            }
            const localVarPath = `/api/item/{itemId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemList(options: any = {}): FetchArgs {
            const localVarPath = `/api/item/getItemList`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemListForLocker(options: any = {}): FetchArgs {
            const localVarPath = `/api/item/overviewLocker`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverview(options: any = {}): FetchArgs {
            const localVarPath = `/api/item/overview`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} itemName
         * @param {string} itemDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overviewItem(itemName: string, itemDate: string, options: any = {}): FetchArgs {
            // verify required parameter 'itemName' is not null or undefined
            if (itemName === null || itemName === undefined) {
                throw new RequiredError('itemName','Required parameter itemName was null or undefined when calling overviewItem.');
            }
            // verify required parameter 'itemDate' is not null or undefined
            if (itemDate === null || itemDate === undefined) {
                throw new RequiredError('itemDate','Required parameter itemDate was null or undefined when calling overviewItem.');
            }
            const localVarPath = `/api/item/{itemName}/{itemDate}`
                .replace(`{${"itemName"}}`, encodeURIComponent(String(itemName)))
                .replace(`{${"itemDate"}}`, encodeURIComponent(String(itemDate)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertById(itemId: string, options: any = {}): FetchArgs {
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling revertById.');
            }
            const localVarPath = `/api/item/revert/{itemId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ItemWrite} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1(body: ItemWrite, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling update1.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling update1.');
            }
            const localVarPath = `/api/item/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ItemWrite" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemControllerApi - functional programming interface
 * @export
 */
export const ItemControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {ItemWrite} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createItem(body: ItemWrite, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = ItemControllerApiFetchParamCreator(configuration).createItem(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = ItemControllerApiFetchParamCreator(configuration).deleteById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {Array<string>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByIds(body: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = ItemControllerApiFetchParamCreator(configuration).deleteByIds(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ItemRead>> {
            const localVarFetchArgs = ItemControllerApiFetchParamCreator(configuration).getHistory(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemById(itemId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemRead> {
            const localVarFetchArgs = ItemControllerApiFetchParamCreator(configuration).getItemById(itemId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemList(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ItemEntity>> {
            const localVarFetchArgs = ItemControllerApiFetchParamCreator(configuration).getItemList(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemListForLocker(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ItemReadOverviewLocker>> {
            const localVarFetchArgs = ItemControllerApiFetchParamCreator(configuration).getItemListForLocker(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverview(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<OverviewDto>> {
            const localVarFetchArgs = ItemControllerApiFetchParamCreator(configuration).getOverview(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} itemName
         * @param {string} itemDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overviewItem(itemName: string, itemDate: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ItemRead>> {
            const localVarFetchArgs = ItemControllerApiFetchParamCreator(configuration).overviewItem(itemName, itemDate, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertById(itemId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = ItemControllerApiFetchParamCreator(configuration).revertById(itemId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ItemWrite} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1(body: ItemWrite, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemRead> {
            const localVarFetchArgs = ItemControllerApiFetchParamCreator(configuration).update1(body, id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ItemControllerApi - factory interface
 * @export
 */
export const ItemControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @param {ItemWrite} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createItem(body: ItemWrite, options?: any) {
            return ItemControllerApiFp(configuration).createItem(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById(id: string, options?: any) {
            return ItemControllerApiFp(configuration).deleteById(id, options)(fetch, basePath);
        },
        /**
         *
         * @param {Array<string>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByIds(body: Array<string>, options?: any) {
            return ItemControllerApiFp(configuration).deleteByIds(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory(options?: any) {
            return ItemControllerApiFp(configuration).getHistory(options)(fetch, basePath);
        },
        /**
         *
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemById(itemId: string, options?: any) {
            return ItemControllerApiFp(configuration).getItemById(itemId, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemList(options?: any) {
            return ItemControllerApiFp(configuration).getItemList(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemListForLocker(options?: any) {
            return ItemControllerApiFp(configuration).getItemListForLocker(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverview(options?: any) {
            return ItemControllerApiFp(configuration).getOverview(options)(fetch, basePath);
        },
        /**
         *
         * @param {string} itemName
         * @param {string} itemDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overviewItem(itemName: string, itemDate: string, options?: any) {
            return ItemControllerApiFp(configuration).overviewItem(itemName, itemDate, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertById(itemId: string, options?: any) {
            return ItemControllerApiFp(configuration).revertById(itemId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ItemWrite} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1(body: ItemWrite, id: string, options?: any) {
            return ItemControllerApiFp(configuration).update1(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * ItemControllerApi - object-oriented interface
 * @export
 * @class ItemControllerApi
 * @extends {BaseAPI}
 */
export class ItemControllerApi extends BaseAPI {
    /**
     *
     * @param {ItemWrite} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemControllerApi
     */
    public createItem(body: ItemWrite, options?: any) {
        return ItemControllerApiFp(this.configuration).createItem(body, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemControllerApi
     */
    public deleteById(id: string, options?: any) {
        return ItemControllerApiFp(this.configuration).deleteById(id, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {Array<string>} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemControllerApi
     */
    public deleteByIds(body: Array<string>, options?: any) {
        return ItemControllerApiFp(this.configuration).deleteByIds(body, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemControllerApi
     */
    public getHistory(options?: any) {
        return ItemControllerApiFp(this.configuration).getHistory(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemControllerApi
     */
    public getItemById(itemId: string, options?: any) {
        return ItemControllerApiFp(this.configuration).getItemById(itemId, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemControllerApi
     */
    public getItemList(options?: any) {
        return ItemControllerApiFp(this.configuration).getItemList(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemControllerApi
     */
    public getItemListForLocker(options?: any) {
        return ItemControllerApiFp(this.configuration).getItemListForLocker(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemControllerApi
     */
    public getOverview(options?: any) {
        return ItemControllerApiFp(this.configuration).getOverview(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {string} itemName
     * @param {string} itemDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemControllerApi
     */
    public overviewItem(itemName: string, itemDate: string, options?: any) {
        return ItemControllerApiFp(this.configuration).overviewItem(itemName, itemDate, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemControllerApi
     */
    public revertById(itemId: string, options?: any) {
        return ItemControllerApiFp(this.configuration).revertById(itemId, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {ItemWrite} body
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemControllerApi
     */
    public update1(body: ItemWrite, id: string, options?: any) {
        return ItemControllerApiFp(this.configuration).update1(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * ItemMySqlControllerApi - fetch parameter creator
 * @export
 */
export const ItemMySqlControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transformItem(options: any = {}): FetchArgs {
            const localVarPath = `/api/item-my-sql/transformItem`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemMySqlControllerApi - functional programming interface
 * @export
 */
export const ItemMySqlControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transformItem(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ItemMySqlControllerApiFetchParamCreator(configuration).transformItem(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ItemMySqlControllerApi - factory interface
 * @export
 */
export const ItemMySqlControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transformItem(options?: any) {
            return ItemMySqlControllerApiFp(configuration).transformItem(options)(fetch, basePath);
        },
    };
};

/**
 * ItemMySqlControllerApi - object-oriented interface
 * @export
 * @class ItemMySqlControllerApi
 * @extends {BaseAPI}
 */
export class ItemMySqlControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemMySqlControllerApi
     */
    public transformItem(options?: any) {
        return ItemMySqlControllerApiFp(this.configuration).transformItem(options)(this.fetch, this.basePath);
    }

}
/**
 * ValidationControllerApi - fetch parameter creator
 * @export
 */
export const ValidationControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmail(body: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling validateEmail.');
            }
            const localVarPath = `/auth/validate/email`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword(body: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling validatePassword.');
            }
            const localVarPath = `/auth/validate/password`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateToken(body: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling validateToken.');
            }
            const localVarPath = `/auth/validate/token`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUsername(body: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling validateUsername.');
            }
            const localVarPath = `/auth/validate/username`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidationControllerApi - functional programming interface
 * @export
 */
export const ValidationControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmail(body: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ValidationResponseEmailErrorCodes> {
            const localVarFetchArgs = ValidationControllerApiFetchParamCreator(configuration).validateEmail(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword(body: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ValidationResponsePasswordErrorCodes> {
            const localVarFetchArgs = ValidationControllerApiFetchParamCreator(configuration).validatePassword(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateToken(body: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ValidationResponseTokenErrorCodes> {
            const localVarFetchArgs = ValidationControllerApiFetchParamCreator(configuration).validateToken(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUsername(body: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ValidationResponseUsernameErrorCodes> {
            const localVarFetchArgs = ValidationControllerApiFetchParamCreator(configuration).validateUsername(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ValidationControllerApi - factory interface
 * @export
 */
export const ValidationControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmail(body: string, options?: any) {
            return ValidationControllerApiFp(configuration).validateEmail(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword(body: string, options?: any) {
            return ValidationControllerApiFp(configuration).validatePassword(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateToken(body: string, options?: any) {
            return ValidationControllerApiFp(configuration).validateToken(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUsername(body: string, options?: any) {
            return ValidationControllerApiFp(configuration).validateUsername(body, options)(fetch, basePath);
        },
    };
};

/**
 * ValidationControllerApi - object-oriented interface
 * @export
 * @class ValidationControllerApi
 * @extends {BaseAPI}
 */
export class ValidationControllerApi extends BaseAPI {
    /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationControllerApi
     */
    public validateEmail(body: string, options?: any) {
        return ValidationControllerApiFp(this.configuration).validateEmail(body, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationControllerApi
     */
    public validatePassword(body: string, options?: any) {
        return ValidationControllerApiFp(this.configuration).validatePassword(body, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationControllerApi
     */
    public validateToken(body: string, options?: any) {
        return ValidationControllerApiFp(this.configuration).validateToken(body, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationControllerApi
     */
    public validateUsername(body: string, options?: any) {
        return ValidationControllerApiFp(this.configuration).validateUsername(body, options)(this.fetch, this.basePath);
    }

}
